import { motion } from 'framer-motion';
import React from 'react';
import { NUMBER_ANIMATION } from '../../constants';

const SummaryCard = (props) => {
  const { stats, title, isVisible, handleClick } = props;

  return (
    <div
      className={`bg-white shadow-lg rounded-3xl p-6 ${handleClick ? 'cursor-pointer hover:bg-[#FFF3EB] transition' : ''}`}
      onClick={handleClick && handleClick}>
      <h2 className="text-xl font-semibold mb-4">{title}</h2>
      <div className="space-y-3">
        {stats.map((item) => {
          const { title, total } = item;
          return (
            <motion.div
              key={title}
              initial="hidden"
              animate={isVisible ? 'visible' : 'hidden'}
              variants={NUMBER_ANIMATION}
              className="flex justify-between text-gray-700">
              <span>{title}</span>
              <span className="text-orange-500 font-bold">{total}</span>
            </motion.div>
          );
        })}
      </div>
    </div>
  );
};
export default SummaryCard;
